import { useDispatch } from "react-redux";
import { Card, Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ParseDate } from "../../../../Helpers/DateHelper";
import ScrollableCard from "../../../SharedComponents/ScrollableCard";
import ProfilePicture from "../../../SharedComponents/ProfilePicture";
import { SetSelectedPageWithoutUrl } from "../../../AppMenu/Store";

const PositionCandidatesList = ({ candidatesList }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <>
      <Card className={"header"}>
        <Row className={"justify-content-between text-20 text-color-gray-light fw-medium"} style={{ height: "50px" }}>
          <Col xs={6} md={4} className={"align-content-center"}>
            <Row>
              <Col xs={2}></Col>
              <Col xs={10}>{t("candidateFullNameLabel")}</Col>
            </Row>
          </Col>
          <Col xs={6} md={4} className={"align-content-center"}>
            <Row className={"justify-content-center"}>{t("candidateEmailLabel")}</Row>
          </Col>
          <Col xs={4} className={"align-content-center d-none d-md-block"}>
            <Row className={"justify-content-end me-5"}>
              <Col xs={"auto"}>{t("Start Date")}</Col>
            </Row>
          </Col>
        </Row>
      </Card>

      <ScrollableCard>
        {candidatesList &&
          candidatesList.map((candidate, i) => (
            <Card className={"list-row"} key={i}>
              <div className={"p-0 hover-bg-darken"}>
                <Row
                  className={"justify-content-between text-20 text-color-gray-dark fw-medium"}
                  onClick={() => {
                    navigate("/candidate", {
                      state: {
                        candidateId: candidate.candidateId,
                        backUrl: "/createPosition",
                      },
                    });
                    dispatch(SetSelectedPageWithoutUrl({ url: "candidate" }));
                  }}
                  style={{ height: "50px" }}
                >
                  <Col xs={6} md={4} className={"align-content-center"}>
                    <Row className={"h-100 justify-content-sm-start justify-content-center"}>
                      <Col sm={"auto"} className={"align-content-center d-none d-sm-block"}>
                        <Row className={"justify-content-end"}>
                          <Col xs={"auto"} className={"pe-0"}>
                            <ProfilePicture
                              userId={candidate.applicationUserId}
                              profilePicFileName={candidate.profilePic}
                              size={40}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col xs={"auto"} sm={"auto"} className={"align-content-center text-sm-start text-center pe-0"}>
                        {candidate.name}
                      </Col>
                    </Row>
                  </Col>
                  <Col xs={6} md={4} className={"align-content-center"}>
                    <Row className={"justify-content-center"}>{candidate.email}</Row>
                  </Col>
                  <Col xs={4} className={"align-content-center d-none d-md-block"}>
                    <Row className={"justify-content-end me-0"}>
                      <Col className={"pe-5"} xs={"auto"}>
                        {ParseDate(candidate.createdAt).date}
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </div>
            </Card>
          ))}
      </ScrollableCard>
    </>
  );
};

export default PositionCandidatesList;
